import { Outlet } from "react-router-dom";

import { Box, ThemeProvider } from "@mui/material";
import { ConfirmProvider } from "material-ui-confirm";
import { theme } from "../theme";
const Layout = () => {
  return (
    <ThemeProvider theme={theme}>
      <ConfirmProvider>
        <Box
          bgcolor={"background.default"}
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Outlet />
        </Box>
      </ConfirmProvider>
    </ThemeProvider>
  );
};

export default Layout;
